import { useEffect, useState } from "react";
import { VStack } from "@chakra-ui/react";
import AppPage from "layouts/AppPage";
import { useNavbar } from "hooks/useNavbar";
import useSideDrawer from "hooks/useSideDrawer";
import FeatureGate from "components/FeatureGate";
import GroupFilters from "../Components/GroupFilters";
import GroupsTable from "../Components/GroupsTable";
import GroupDetailDrawer from "../Components/GroupDetailDrawer";
import { GROUPS_MANAGEMENT_FEATURE_FLAG } from "../constants";
import type { Group, GroupsFilters } from "../types";

const DEFAULT_SORT = "name_asc";

function GroupsPageContent() {
  const [filters, setFilters] = useState<GroupsFilters>({});
  const [searchValue, setSearchValue] = useState("");
  const [currentSort, setCurrentSort] = useState<string>(DEFAULT_SORT);
  const drawer = useSideDrawer<Group, string>({ getItemId: (g) => (g ? String(g.id) : undefined) });
  const { setBackLocationPath, setBackLocationName, setPageTitle } = useNavbar();

  useEffect(() => {
    setPageTitle("Groups");
    return () => {
      setPageTitle(null);
      setBackLocationName(null);
      setBackLocationPath(null);
    };
  }, [setBackLocationName, setBackLocationPath, setPageTitle]);

  return (
    <AppPage>
      <VStack spacing={4} alignItems="stretch">
        <GroupFilters
          filters={filters}
          searchValue={searchValue}
          currentSort={currentSort}
          onFiltersChange={setFilters}
          onSearchChange={setSearchValue}
          onSortChange={setCurrentSort}
          onReset={() => {
            setFilters({});
            setSearchValue("");
            setCurrentSort(DEFAULT_SORT);
          }}
        />
        <GroupsTable
          filters={filters}
          searchValue={searchValue}
          currentSort={currentSort}
          onSelectGroup={drawer.expandClickHandlerByItem}
        />
      </VStack>

      <GroupDetailDrawer
        group={drawer.selectedItem}
        isOpen={drawer.isOpen}
        onClose={drawer.onClose}
      />
    </AppPage>
  );
}

export default function GroupsPage() {
  return (
    <FeatureGate feature={GROUPS_MANAGEMENT_FEATURE_FLAG}>
      <GroupsPageContent />
    </FeatureGate>
  );
}
